import { render, staticRenderFns } from "./operation-board-crew.vue?vue&type=template&id=5dde0962&scoped=true&"
import script from "./operation-board-crew.vue?vue&type=script&lang=js&"
export * from "./operation-board-crew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dde0962",
  null
  
)

export default component.exports